import pino from "pino";

/**
 * Base logger for the SPA, configured for pretty output.
 */
const baseLogger = pino({
  level: "debug",
  transport: { target: "pino-pretty", options: { colorize: true } },
});

/**
 * Return a logger scoped to the given phase/area.
 * Logged output will include the `scope` key.
 *
 * @param {string} scope - Human-readable scope or phase (e.g. 'Loading', 'Event:CustomContact')
 */
export function ScopedLogger(scope) {
  return baseLogger.child({ scope });
}

export default baseLogger;
